export const FLOW_STATE_KEYS = {
  INITIAL_ONBOARDING: "InitialOnboarding",
  FAST_CRAWL: "FastCrawl",
  CHROME_FEED_ONBOARDING: "ChromeFeedOnboarding",
};
